import { GridPostParams, GridModel } from "common/models/utility-models/list-utility.model";
import { TravelReimbursementModel } from "./travel-reimbursement-data.model";

export class TravelReimbursementGridPostParams extends GridPostParams {
    student_id: string = ''
}

export class TravelReimbursementGridModel extends TravelReimbursementModel { }

export class TravelReimbursementListingModel extends GridModel<TravelReimbursementGridModel> { }